import { useEffect } from "react";

export const SEO = ({ title, description }) => {
    useEffect(() => {
        document.title = title;
        const meta = document.querySelector('meta[name="description"]');
        if (meta) meta.setAttribute("content", description);
        const og = document.querySelector('meta[property="og:title"]');
        if (og) og.setAttribute("content", title);
        const tw = document.querySelector('meta[name="twitter:title"]');
        if (tw) tw.setAttribute("content", title);
    }, [title, description]);
    return null;
};
